import React from 'react'
import i18n from 'i18next'

import { NavGroup } from '~shared/models/NavigationModels'
import Dashboard from '~app/screens/Dashboard/Dashboard'
import InviteColleagues from '~app/screens/InviteColleagues/InviteColleagues'
import ServiceReportOnline from '~app/screens/ServiceReportOnline/ServiceReportOnline'
import PartsOnDemand from '~app/screens/PartsOnDemand/PartsOnDemand'
import Empolis from '~app/screens/Empolis/Empolis'
import Trainings from '~app/screens/Trainings/Trainings'
import ShoppingCartOutlined from '@mui/icons-material/ShoppingCartOutlined'
import PersonAdd from '@mui/icons-material/PersonAdd'
import PlayCircleFilled from '@mui/icons-material/PlayCircleFilled'
import IconHome from '@mui/icons-material/Home'
import SchoolIcon from '@mui/icons-material/School'
import IconBusiness from '@mui/icons-material/Business'
import IconSchool from '@mui/icons-material/School'
import IconPeople from '@mui/icons-material/People'
import IconHeadSnowflake from '~shared/components/icons/IconHeadSnowflake'
import IconHammerScrewdriver from '~shared/components/icons/IconHammerScrewdriver'
import RegistrationCustomerPortal from '~app/screens/RegistrationCustomerPortal/RegistrationCustomerPortal'
import RegistrationCourse from '~app/screens/RegistrationCourse/RegistrationCourse'
import CrudeContainer from '~app/components/Crude/CrudeContainer'
import Academy from '~app/screens/Academy/Academy'
import SpareAxleRequest from '~app/screens/SpareAxleRequest/SpareAxleRequest'
import IconSpareAxleRequest from '~assets/icons/Icon_SpareAxleRequest.svg'
import Software from "~app/screens/Software/Software";
import IconDownload from "~shared/components/icons/IconDownload";

export const getAppNavItemGroups: () => NavGroup[] = () => {
  const navGroups: NavGroup[] = []

  /**
   * Group - Main
   */
  navGroups.push({
    position: 0,
    items: [
      {
        hideOnDashboard: true,
        label: i18n.t('common:navLabelDashboard'),
        description: i18n.t('common:navDescDashboard'),
        icon: <IconHome color='primary' style={{ fontSize: 28 }} />,
        route: {
          exact: true,
          path: '/',
          component: Dashboard,
        },
      },
      {
        hideOnDashboard: true,
        label: i18n.t('common:navLabelInviteColleagues'),
        description: i18n.t('common:navDescInviteColleagues'),
        icon: <PersonAdd color='primary' style={{ fontSize: 28 }} />,
        route: {
          exact: true,
          path: '/inviteColleagues',
          component: InviteColleagues,
        },
      },
      {
        hideOnDashboard: true,
        label: i18n.t('common:navLabelEmpolis'),
        description: i18n.t('common:navDescEmpolis'),
        icon: <IconHeadSnowflake width='24px' />,
        route: {
          exact: true,
          path: '/empolis',
          component: Empolis,
        },
      },
      {
        hideOnDashboard: true,
        label: i18n.t('common:navLabelPod'),
        description: i18n.t('common:navDescPod'),
        icon: <ShoppingCartOutlined color='primary' />,
        route: {
          exact: true,
          path: '/pod',
          component: PartsOnDemand,
        },
      },
      {
        hideOnDashboard: true,
        label: i18n.t('common:navLabelServiceReportOnline'),
        description: i18n.t('common:navDescServiceReportOnline'),
        icon: <IconHammerScrewdriver width='22px' />,
        route: {
          exact: true,
          path: '/serviceReportOnline',
          component: ServiceReportOnline,
        },
      },
      {
        hideOnDashboard: true,
        label: i18n.t('common:navLabelSpareAxleRequest'),
        description: i18n.t('common:navDescSpareAxleRequest'),
        icon: <IconSpareAxleRequest style={{ width: '16px', height: '16px', scale: '4' }} />,
        route: {
          exact: true,
          path: '/spareAxleRequest',
          component: SpareAxleRequest,
        },
      },
      {
        hideOnDashboard: true,
        label: i18n.t('common:navLabelSoftware'),
        // TODO: description: i18n.t('common:navDescSoftware'),
        icon: <IconDownload />,
        route: {
          exact: true,
          path: '/software',
          component: Software,
        },
      },
    ],
  })

  // disabled since 07.09.2022
  // on request in ticket https://jira.3m5.de/browse/SHK-241
  // /**
  //  * Group - Trainings
  //  */
  navGroups.push({
    label: i18n.t('common:navTrainings'),
    position: 1,
    items: [
      // {
      //   hideOnDashboard: true,
      //   label: i18n.t('common:navLabelTrainings'),
      //   description: i18n.t('common:navDescTrainings'),
      //   icon: <PlayCircleFilled color='primary' />,
      //   route: {
      //     exact: true,
      //     path: '/trainings',
      //     component: Trainings,
      //   },
      // },
      {
        hideOnDashboard: true,
        label: i18n.t('common:navLabelAcademy'),
        icon: <SchoolIcon color='primary' />,
        route: {
          exact: true,
          path: '/academy',
          component: Academy,
        },
      },
      {
        hideOnDashboard: true,
        label: i18n.t('common:navLabelRegistration'),
        description: i18n.t('common:navDescRegistration'),
        icon: <IconSchool color='primary' />,
        route: {
          exact: true,
          path: '/registration',
          component: RegistrationCourse,
        },
      },
    ],
  })

  /**
   * Group - Crude
   */
  navGroups.push({
    label: i18n.t('common:administration'),
    position: 2,
    items: [
      {
        label: i18n.t('common:navLabelBusiness'),
        description: i18n.t('common:navDescBusiness'),
        icon: <IconBusiness color='primary' />,
        position: 0,
        route: {
          exact: true,
          path: '/crude/company',
          component: CrudeContainer,
        },
      },
      {
        label: i18n.t('common:navLabelUser'),
        description: i18n.t('common:navDescUser'),
        icon: <IconPeople color='primary' />,
        position: 1,
        route: {
          exact: true,
          path: '/crude/user',
          component: CrudeContainer,
        },
      },
    ],
  })

  return navGroups
}
